import axios from 'axios';

import { ACCEPTANCE_METHOD_WEB_FORM, CONSENT_TEXT, CONTACT_METHOD_SMS, LEGAL_BASIS_CONSENT } from './constants';

// Snake_case property names match the JSON wire format from the C# backend (Newtonsoft.Json [JsonProperty] attributes)
type ConsentPermission = {
  contact_methods: string[];
  accepted: boolean;
  legal_basis: {
    gdpr: string;
  };
  acceptance_method: {
    type: string;
  };
  consent_text: string;
};

type PhonePermissions = {
  customer_service?: ConsentPermission;
  service_alerts?: ConsentPermission;
};

type VerifiedPhoneNumber = {
  phone_number: string;
  permissions: PhonePermissions;
};

type UserVerifiedPhoneNumberResponse = {
  user_verified_phone_numbers: VerifiedPhoneNumber[];
};

type UpdatePermissionsPayload = {
  user_verified_phone_numbers: VerifiedPhoneNumber[];
};

const buildConsentPermission = (accepted: boolean): ConsentPermission => ({
  contact_methods: [CONTACT_METHOD_SMS],
  accepted,
  legal_basis: {
    gdpr: LEGAL_BASIS_CONSENT,
  },
  acceptance_method: {
    type: ACCEPTANCE_METHOD_WEB_FORM,
  },
  consent_text: CONSENT_TEXT,
});

export const buildPhoneConsentPayload = (phoneNumber: string, accepted: boolean): UpdatePermissionsPayload => ({
  user_verified_phone_numbers: [
    {
      phone_number: phoneNumber,
      permissions: {
        customer_service: buildConsentPermission(accepted),
        service_alerts: buildConsentPermission(accepted),
      },
    },
  ],
});

export const getPhoneConsent = async (): Promise<UserVerifiedPhoneNumberResponse> => {
  const response = await axios.get('/userVerifiedPhoneNumber');
  return response.data;
};

export const updatePhoneConsent = async (phoneNumber: string, accepted: boolean): Promise<void> => {
  const payload = buildPhoneConsentPayload(phoneNumber, accepted);
  await axios.post('/userVerifiedPhoneNumber/permissions', payload);
};

export const hasExistingConsent = (consentData: UserVerifiedPhoneNumberResponse | null): boolean => {
  if (!consentData?.user_verified_phone_numbers?.length) {
    return false;
  }

  return consentData.user_verified_phone_numbers.some(
    (entry) => entry.permissions?.customer_service?.accepted === true || entry.permissions?.service_alerts?.accepted === true,
  );
};
